import React, { useRef, useState, useEffect } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import Moment from 'react-moment';
import 'moment/locale/es';
import moment from 'moment';
import { API } from "aws-amplify";
import Cookie from 'js-cookie';
import { Container, Row, Col, Button, Badge, Tab, Nav, Table } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Form } from "react-bootstrap/";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlayCircle, faInfoCircle, faCircle } from '@fortawesome/free-solid-svg-icons'
import { faQrcode, faCheckCircle, faTimesCircle, faSpinner, faExclamationTriangle, faTicketAlt } from '@fortawesome/free-solid-svg-icons'
import Linkify from 'react-linkify';
import ReactHtmlParser from 'react-html-parser'; 


import AdmissionScanner from "components/AdmissionScanner";
import AdmissionList from "components/AdmissionList";
import TokenScanner from "components/TokenScanner";
import TokenList from "components/TokenList";
import GiftScanner from "components/GiftScanner";
import ShowStats from "components/ShowStats";
import TokenStats from "components/TokenStats";
import GiftStats from "components/GiftStats";

import { onError, Notification } from "../libs/errorLib";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { renderCountryOptions } from "../libs/formsLib";
import config from '../config';

import "../../node_modules/noty/lib/noty.css";
import "../../node_modules/noty/lib/themes/bootstrap-v4.css";
import "./Show.css";
import Loader from "components/Loader";

export default function Show(props) {
    
  //const file = useRef(null);
  const { id } = useParams();
  const location = useLocation();
  const history = useHistory();
  const {isAuthenticated, getSession } = useAppContext();
  const [session, setSession] = useState(null);
  const [show, setShow] = useState(null);
  const [admin, setAdmin] = useState(false);
  const [showIsActive, setShowIsActive] = useState(false);
  const [showHasDates, setShowHasDates] = useState(false);

  const [showDates, setShowDates] = useState([]);
  const [selectedShow, setSelectedShow] = useState(null);
  const [viewerShow, setViewerShow] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [showMap, setShowMap] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [showTicket, setShowTicket] = useState(null);
  const [showAdmission, setShowAdmission] = useState(false) 
  
  const [isLoading, setIsLoading] = useState(false);  
  const [status, setStatus] = useState('loading');
  const [admissionType, setAdmissionType] = useState(null)

  const [salesLoading, setSalesLoading] = useState(false);  
  const [codesLoading, setCodesLoading] = useState(false);  
  const [fields, handleFieldChange] = useFormFields({    
    selectedTicket: "none",  
  });
  
  const linkifyComponentDecorator = (href, text, key) => (
    <a href={href} key={key} target="_blank">
        {text}
    </a>
    );

    useEffect(() => {

    // const searchParams = new URLSearchParams(location.search);
    // if (searchParams.get('activated') == "1") {
    //     Notification('success','Tu boleto ha sido activado exitosamente')
    // }

    async function onLoad() {
        try {           
            setIsLoading(true)
            let sess = getSession()
            setSession(sess)
            
            const show = await loadShow();
            loadChildShows()
            setShowIsActive(['ACTIVE','STARTED','LIVE','REPLAY','SOLD OUT','TEST'].includes(show.status))

            let allowed = false
            if (sess.user.roles.includes('Admin')) {
                allowed = true
                setAdmin(true)
            } else {
                const producer = sess.producers.find(p => p._id == show.producer)
                if (producer) {
                    allowed = true
                } else {
                    if (show.users.includes(sess.session.user_uid)) {
                        allowed = true
                    }
                }
                // if (sess.producers.contains(show.producer))
            }
            if (allowed) {
                setShow(show)
                setSelectedShow(show)
            } else {
                history.push('/')
            }            

        } catch (e) {
            onError(e);
        } finally {
            setIsLoading(false)
        }
    }

    onLoad();
    }, [id]);

    useEffect(() => {

        async function onShowChanged() {
            try {
                setIsLoading(true)

                if (selectedShow) {                
                    setShowIsActive(['ACTIVE','STARTED','LIVE','REPLAY','SOLD OUT','TEST'].includes(selectedShow.status))
                    
                    const tickets = await loadShowTickets(selectedShow)
                    if (selectedShow?.settings?.has_map) {
                        loadShowMap(selectedShow._id)
                    } else {
                        console.log('selectFirst', tickets)
                        selectFirstTicket(tickets)
                    }
                    setShowHasDates(selectedShow?.settings?.has_show_dates || false)
                } else {
                    setTickets([])
                    setShowTicket(null)
                    setSelectedLocation(null)
                }
            } catch (e) {
                alert("Ocurrio un error")
                console.log(e)
            } finally {
                setIsLoading(false)
            }
        }
        onShowChanged()
        console.log('selected', selectedShow)

    }, [selectedShow]);

    /* API CALLS  */

    async function loadShow() {
        return API.get("vivelo", `/shows/${id}`);
    }
    async function loadChildShows() {
        const children = await API.get("vivelo", `/shows/?parent=${id}&filter=ALL&visible=-1`);
        const dates = children && children.items ? children.items : []
        setShowDates(dates)
    }
    async function loadShowTickets(show) {
        // const courtesiesFilter = props.courtesies ? '&courtesy=1' : ''
        // const paymentFilter = props.courtesies ? '' : '&paymentType=PREPAID'
        const courtesiesFilter = '&courtesy=-1'
        const paymentFilter = ''

        const tickets = await API.get("vivelo", `/shows/${show._id}/tickets?${courtesiesFilter}${paymentFilter}`);
        if (tickets && tickets.items && tickets.items.length > 0) {
            tickets.items.forEach(t => { t.selected = 0 })
            setTickets(tickets.items)
            setShowTicket(null)
        }
        return tickets.items || []
    }
    async function loadShowMap(show_uid) {
        const map = await API.get("vivelo", `/shows/${show_uid}/map`);        
        setShowMap(map)
    }

    function renderStatus() {        
        switch(show.status) {
            case 'NEW': return <Badge variant="secondary" >NUEVO</Badge> 
            case 'SOON': return <Badge variant="info" >PROacute;XIMAMENTE</Badge>
            case 'ACTIVE': return <Badge variant="primary" >ACTIVO</Badge>
            case 'STARTED': return <Badge variant="primary" >INICIDO</Badge>
            case 'REPLAY': return <Badge variant="primary" >RETRAMISION</Badge>
            case 'LIVE': return <Badge variant="success" >EN VIVO</Badge>
            case 'SOLD': return <Badge variant="warning" >BOLETOS AGOTADOS</Badge>
            case 'CLOSED': return <Badge variant="dark" >CERRADO</Badge>
            case 'HIDDEN': return <Badge variant="dark" >ESCONDIDO</Badge>
            case 'CANCELLED': return <Badge variant="dark" >CANCELADO</Badge>             
        }
    }

    function renderShowInfo() {
        return <div style={{marginTop: 20}}>
            <Row>
        <Col md="4" className="">
            <div className="show-image">                    
                    <img src={`${show.main_image}`} />
                    {viewerShow && ['STARTED','LIVE','REPLAY'].includes(show.status) && <>
                    <div className="play-overlay">
                        <a href={`/shows/${show._id}/play`} target="_blank" className="d-flex justify-content-center align-items-center"><FontAwesomeIcon icon={faPlayCircle} /></a>
                        {show.status == "LIVE" &&
                        <div className="live-overlay"><div><FontAwesomeIcon icon={faCircle} style={{color:"red"}} />&nbsp;&nbsp;EN VIVO</div></div>
                        }
                    </div>                            
                    </>}
                    
            </div>                                           
        </Col>    
        <Col md="8" className="Show">
            <Row className="show-description"><Col>
                <><Linkify componentDecorator={linkifyComponentDecorator}>{ReactHtmlParser(show.description)}</Linkify></>
            </Col></Row>
            <Row className="show-description"><Col>
                <h2>{renderStatus()}</h2>
                </Col></Row>
            { false && <Row className="show-description">
                <Col md="3">
                <Form>
                    <Form.Group controlId="exampleForm.ControlSelect1">
                        <Form.Label>Nuevo Estado</Form.Label>
                        <Form.Control as="select">
                        <option value="NEW" selected={show.status == "NEW"}>NUEVO</option>
                        <option value="ACTIVE" selected={show.status == "ACTIVE"}>ACTIVO</option>
                        <option value="STARTED" selected={show.status == "STARTED"}>INICIADO</option>
                        <option value="LIVE" selected={show.status == "LIVE"}>EN VIVO</option>
                        <option value="REPLAY" selected={show.status == "REPLAY"}>RETRANSMISIÓN</option>
                        <option value="SOLD OUT" selected={show.status == "SOLD OUT"}>BOLETOS AGOTADOS</option>
                        <option value="CLOSED" selected={show.status == "CLOSED"}>CERRADO</option>
                        <option value="HIDDEN" selected={show.status == "HIDDEN"}>ESCONDIDO</option>
                        <option value="CANCELLED" selected={show.status == "CANCELLED"}>CANCELADO</option>
                        </Form.Control>
                        <Button >Cambiar Estado</Button>
                    </Form.Group>                    
                </Form>
                </Col>
                <Col>
                
                    </Col></Row> }
        </Col>  
    </Row>
            
            
                       
            
        
    </div>
    }

    function onTicketChange(event) {
        try {
            setIsLoading(true)
            setShowTicket(null)

            var selectElement = event.target;
            var ticket_uid = selectElement.value
            if (ticket_uid) {
                const ticket = tickets.find(t => t._id == ticket_uid)
                setShowTicket(ticket)
            } else {
                setShowTicket(null)
            }
        } catch (e) {
            alert('Ocurrio un error')
            console.log(e)
        } finally {
            setIsLoading(false)
        }
    }

    function renderTickets() {
        const options = []
        options.push(<option key={`opt-${show._id}`} value="">-- Selecciona el tipo de boleto --</option>)
        tickets
            .filter(t => ['VENUE_OPEN','VENUE_CLOSED'].includes(t.type))
            .map(t => {
                options.push(<option key={t._id} value={t._id}>{t.fullname}</option>)                
            })
                    
        return <Form.Control as="select" onChange={onTicketChange}>
                    {options}
                </Form.Control>
        
    }

    function selectFirstTicket(tickets) {
        console.log('tickets', tickets)
        // if (!showTicket && tickets) {
        // if (tickets)
            const ticket = tickets.length > 0 ? tickets[0] : null
            console.log(ticket)
            setShowTicket(ticket)
        // }
    }

    function onLocationChange(event) {
        try {
            setIsLoading(true)
            setShowTicket(null)
            setSelectedLocation(null)

            var selectElement = event.target;
            var location_uid = selectElement.value
            if (location_uid) {
                const location = showMap.locations.find(l => l._id == location_uid)
                setSelectedLocation(location)
                console.log('selected location', location)
                // console.log(tickets)
                // const ticket = tickets.find(t => t._id == location.show_ticket_uid)
                const ticket = tickets.find(t => t._id == location.show_tickets[0])                
                console.log('selected ticket', ticket)
                setShowTicket(ticket)
            } else {
                setSelectedLocation(null)
            }
        } catch (e) {
            alert('Ocurrio un error')
            console.log(e)
        } finally {
            setIsLoading(false)
        }
    }

    function renderLocations() {
        const options = []
        options.push(<option key={`location-${show._id}`} value="">-- Selecciona la localidad --</option>)
        showMap.locations
            // .filter(t => ['VENUE_OPEN','VENUE_CLOSED'].includes(t.type))
            .map(l => {
                options.push(<option key={l._id} value={l._id}>{l.name}</option>)                
            })
                    
        return <Form.Control as="select" onChange={onLocationChange}>
                    {options}
                </Form.Control>
        
    }
    
    function onShowDateChange(event) {
        var selectElement = event.target;
        var show_id = selectElement.value;
        if (!show_id) {
            
            setSelectedShow(show)
        } else {
            const selected = showDates.find(s => s._id == show_id)
            console.log('selected date', selected)
            setSelectedShow(selected)
        }

        
        
    }

    function render() {
        let dateElem = <Moment local format="ddd, LL - LT">{new Date(show.show_date)}</Moment>
        const dates = []
        if (show?.settings?.has_show_dates) {
            const options = [];
            options.push(<option key={show._id} value="">-- Selecciona una función --</option>)
            showDates.map(s => {
                const name = moment(s.show_date).format('LL - h:mm A')
                //<Moment local format="LLLL">{new Date(s.show_date)}</Moment><
                options.push(<option key={s._id} value={s._id}>{name}</option>)
            })
            

            // dateElem = <select>{options}</select>
            dateElem = <Form.Control as="select" onChange={onShowDateChange}>
                        {options}
                    </Form.Control>
        } else {            
            //setSelectedShow(show)
        } 

        return /*!isLoading &&*/ selectedShow ? <>
        <Container fluid className="Show content content-dark">
            <div className="show-header">
                <div>
                    <div><h1>{show.fullname}</h1></div>
                    <div className="show-date">{dateElem}</div>
                </div>                
            </div>
            { (selectedShow?.settings?.is_show_date || !selectedShow?.settings?.has_show_dates) && <>            
            <div>                
                {selectedShow?.settings?.has_map && showMap ? renderLocations() : null }
            </div>
            </> }
            { !isLoading && (selectedShow?.settings?.is_show_date || !selectedShow?.settings?.has_show_dates) && showTicket && <div className="show-actions">
                    {/* <a href={`/shows/${id}/sales`} ><Button variant="outline-light">Ventas</Button></a> */}
                    {/* <a href={`/shows/${id}/registration`} ><Button variant="outline-light">Registro</Button></a> */}
                    <Button variant="outline-light" size="sm" onClick={() => setAdmissionType('QR')}>Admisión QR</Button>
                    <Button variant="outline-light" size="sm" onClick={() => setAdmissionType('LIST')}>Admisión Listado</Button>
                    {selectedShow?.settings?.has_tokens && <Button variant="outline-light" size="sm" onClick={() => setAdmissionType('TOKEN')}>Tokens QR</Button>}
                    {selectedShow?.settings?.has_tokens && <Button variant="outline-light" size="sm" onClick={() => setAdmissionType('TOKENLIST')}>Tokens Listado</Button>}
                    {selectedShow?.settings?.has_gifts && <Button variant="outline-light" size="sm" onClick={() => setAdmissionType('GIFTS')}>Regalos</Button>}
                </div> }
            { !isLoading && showTicket && admissionType=='QR' && <AdmissionScanner show={selectedShow} showTicket={showTicket} showLocation={selectedLocation} onClose={() => setAdmissionType(null) } testMode={!!selectedShow?.settings?.test_mode} /> }
            { !isLoading && showTicket && admissionType=='LIST' && <AdmissionList show={selectedShow} showTicket={showTicket} showLocation={selectedLocation} onClose={() => setAdmissionType(null) } /> }
            { !isLoading && admissionType=='TOKEN' && <TokenScanner show={selectedShow} showTicket={showTicket} showLocation={selectedLocation} onClose={() => setAdmissionType(null) } /> }
            { !isLoading && admissionType=='TOKENLIST' && <TokenList show={selectedShow} showTicket={showTicket} showLocation={selectedLocation} onClose={() => setAdmissionType(null) } /> }
            { !isLoading && admissionType=='GIFTS' && <GiftScanner show={selectedShow} showTicket={showTicket} showLocation={selectedLocation} onClose={() => setAdmissionType(null) } /> }
            <div>
            { !isLoading && (selectedShow?.settings?.is_show_date || !selectedShow?.settings?.has_show_dates) && 
              !['QR','LIST','TOKEN','TOKENLIST','GIFTS'].includes(admissionType) && <ShowStats show={selectedShow} showTicket={showTicket} /> }
            { !isLoading && (selectedShow?.settings?.is_show_date || !selectedShow?.settings?.has_show_dates) && 
                selectedShow?.settings?.has_tokens &&
              !['QR','LIST','TOKEN','TOKENLIST','GIFTS'].includes(admissionType) && <TokenStats show={selectedShow} /> }  
            { !isLoading && (selectedShow?.settings?.is_show_date || !selectedShow?.settings?.has_show_dates) &&
                selectedShow?.settings?.has_gifts &&
              !['QR','LIST','TOKEN','TOKENLIST','GIFTS'].includes(admissionType) && <GiftStats show={selectedShow} /> }  
            </div>
            { isLoading && <Loader /> }
            
        </Container>
        </> : <></>
    };

    return /*!isLoading &&*/ selectedShow && showDates ? render() : <></>;
}